import { Check } from 'lucide-react';

export interface CheckboxRowProps {
  checked: boolean;
  label: string;
}

export function CheckboxRow({ checked, label }: CheckboxRowProps) {
  return (
    <div className='mk-check'>
      <span className={`mk-check__box${checked ? ' is-checked' : ''}`}>
        {checked ? <Check size={13} strokeWidth={3.2} /> : null}
      </span>
      <span className='mk-check__label'>{label}</span>
    </div>
  );
}
